import React, { useEffect, useState } from "react";

const DefaultColor = "transparent";
const selectedColor = "#242527";

const ThumbnailViewer = ({ floorPlans, selectedFloor, handleSelectFloor }) => {
	const [selectedFloorPlan, setSelectedFloorPlan] = useState([null]);

	useEffect(() => {
		setSelectedFloorPlan(selectedFloor);
	}, [selectedFloor]);

	const styles = {
		container: {
			display: "grid",
			gridTemplateColumns: "repeat(auto-fill, minmax(calc(50% - 10.5px), 1fr))",
			columnGap: "21px", // Horizontal space between items
			rowGap: "21px", // Vertical space between rows
			width: "100%"
		},
		wrapper: {
			borderRadius: "10px",
			transition: "border-color 0.3s ease",
			cursor: "pointer",
			aspectRatio: "5/4",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			flex: "1" // Added to ensure uniform height
		},
		floorPlanName: {
			textAlign: "center",
			fontStyle: "normal",
			fontVariant: "normal",
			fontWeight: "medium",
			fontSize: "10px",
			lineHeight: "11px",
			fontFamily: "Roboto",
			letterSpacing: "0px",
			color: "#FFFFFF",
			marginTop: "10px",
			marginBottom: "10px",
			width: "140px",
			whiteSpace: "nowrap",
			overflow: "hidden",
			textOverflow: "ellipsis",
			padding: "0px 20px 0px 20px"
		},
		imageContainer: {
			flex: "1", // Ensures it stretches to fill parent container
			width: "100%", // Matches parent's width
			overflow: "hidden",
			display: "flex", // Added to align image correctly
			justifyContent: "center",
			alignItems: "center",
			marginBottom: "31px",
			padding: "10px"
		},
		floorPlanImage: {
			flex: "1",
			width: "100%",
			overflow: "hidden",
			display: "flex",
			justifyContent: "center",
			alignItems: "center"
		}
	};

	return (
		<div style={styles.container}>
			{floorPlans.map((floorPlan, index) => (
				<div
					key={index}
					style={{
						border: selectedFloorPlan?.id === floorPlan.id ? "2px solid #35B7F3" : "1px solid #494D52",
						backgroundColor: selectedFloorPlan?.id === floorPlan.id ? selectedColor : DefaultColor,
						...styles.wrapper
					}}
					onMouseEnter={(e) => {
						if (selectedFloorPlan?.id !== floorPlan.id) {
							e.currentTarget.style.borderColor = "#9DA5AF";
							e.currentTarget.style.backgroundColor = selectedColor;
						}
					}}
					onMouseLeave={(e) => {
						if (selectedFloorPlan?.id !== floorPlan.id) {
							e.currentTarget.style.borderColor = "#474B50";
							e.currentTarget.style.backgroundColor = DefaultColor;
						}
					}}
					onClick={() => {
						setSelectedFloorPlan(floorPlan);
						handleSelectFloor(floorPlan);
					}} data-testid="orion-components-profiles-widgets-floor-plan-widget-thumbnail-viewer-div"
				>
					<div
						style={{
							...styles.floorPlanName,
							opacity: selectedFloorPlan?.id === floorPlan.id ? 1 : 0.75
						}}
							>{floorPlan.name}
					</div>
					<div style={styles.imageContainer}>
						<img
							style={styles.floorPlanImage}
							src={`/_fileDownload?bucketName=cb2-attachment&fileName=${floorPlan.handle}-thumbnail`}
							alt={`${floorPlan.name} Image Thumbnail`}
							onError={(e) => {
								e.target.onerror = null; // Prevent infinite loop if fallback also fails
								e.target.src = `/_fileDownload?bucketName=cb2-attachment&fileName=${floorPlan.handle}`;
							}} data-testid="orion-components-profiles-widgets-floor-plan-widget-thumbnail-viewer-img"
						/>
					</div>
				</div>
			))}
		</div>
	);
};

export default ThumbnailViewer;
